module.exports = __webpack_public_path__ + "static/media/phone.97fc71c7.gif";